// extracted by mini-css-extract-plugin
export const latests = "latests-module--latests--14AUv";
export const title = "latests-module--title--2vzjh";
export const slide = "latests-module--slide--3Rdii";
export const slideContent = "latests-module--slide-content--3GxLY";
export const slideItem = "latests-module--slideItem--14DbY";
export const prev = "latests-module--prev--8jJ5Y";
export const next = "latests-module--next--3jHBL";